export var findFacetValueInFilters = function findFacetValueInFilters(name, filters, filterType) {
  var filter = filters.find(function (f) {
    return f.field === name && f.type === filterType;
  });
  if (!filter) return;
  return filter.values;
};